import React from 'react';
import { connect } from "react-redux";
import {withRouter} from 'react-router';
import Signature from '../../lib/react-s3/Signature'
import Policy from '../../lib/react-s3/Policy'
import {xAmzDate, dateYMD} from '../../lib/react-s3/Date'
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ProgressBar from './ProgressBar';

import * as uploadActions from "../../actions/upload"

import {BUCKET_NAME, ALBUM_NAME, REGION, ACCESS_KEY_ID, SECRET_ACCESS_KEY } from '../../constants/';

var progressPercentage =0;
var progressObj;
var progressId = 'progress-bar-wrapper';
class ReactS3 {
    static upload(file, config, fn) {

        console.log(file);
        const fd = new FormData();
        const key = `${config.albumName ? config.albumName + '/' : ''}${fn}`;
        const url = `https://${config.bucketName}.s3.amazonaws.com/`
        fd.append('key', key);
        fd.append('acl', 'public-read');
        fd.append('Content-Type', file.type);
        fd.append('x-amz-meta-uuid', '14365123651274');
        fd.append('x-amz-server-side-encryption', 'AES256')
        fd.append('X-Amz-Credential', `${config.accessKeyId}/${dateYMD}/${config.region}/s3/aws4_request`);

        fd.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');
        fd.append('X-Amz-Date', xAmzDate)
        fd.append('x-amz-meta-tag', '');
        fd.append('Policy', Policy.getPolicy(config))
        fd.append('X-Amz-Signature', Signature.getSignature(config, dateYMD, Policy.getPolicy(config)));
        fd.append("file", file);

        return new Promise(async(resolve, reject) => {

            let xhr = new XMLHttpRequest();

            xhr.addEventListener("progress", updateProgress);

            xhr.upload.addEventListener("loadstart", startUpload, false);
            xhr.upload.addEventListener("progress", updateProgress, false);
            xhr.upload.addEventListener("load", uploadCompleted, false)


            xhr.open('POST', url);
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    //resolve(xhr.response);
                    console.log("success");
                    resolve({
                        bucket: config.bucketName,
                        key: `${config.albumName ? config.albumName + '/' : ''}${fn}`,
                        location: `${url}${config.albumName ? config.albumName +'/' : ''}${fn}`,
                        result: xhr.response
                    })

                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                    console.log("error");
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send(fd);


            function startUpload (e) {
                console.log("üpload started");

                progressObj = ReactDOM.render(React.createElement(ProgressBar), document.getElementById(progressId));

                console.log(progressObj);
            }

            function updateProgress (e) {
                if (e.lengthComputable) {
                    var percentComplete = e.loaded / e.total * 100;

                    progressObj.onProgress( percentComplete);

                } else {
                    // Unable to compute progress information since the total size is unknown
                }
            }

            function uploadCompleted (e) {
                console.log("üpload completed");
            }
        })

    }
}

class UploadFile extends React.Component{
    constructor(props){
        super();
        this.state = {
            qData: '',
            uploadQ: {},
            imageHolder:true,
            selectedFile: null,
            completed: 5

        }
        console.log("progressPercentage"+progressPercentage);
        this.fileChangedHandler = this.fileChangedHandler.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
       // this.onUploadProgress = this.onUploadProgress.bind(this);
    }
    componentWillMount(){
        this.setState({uploadQ:{}})
    }
    componentDidMount() {
        let dat={}
        this.setState({uploadQ:dat})
        this.setState({imgurl:this.props.imgurl})
        progressId = this.props.progress?this.props.progress :'progress-bar-wrapper' ;
    }
    componentWillReceiveProps(nextProps) {

        console.log(nextProps);
    }

    onUploadSuccess(r){

        this.setState({imgurl: r.location});
        this.props.getUploadedFile(this.state.imgurl);


        console.log("this.state.imgurl"+this.state.imgurl);
        this.setState({completed:100});
    }

    /*onUploadProgress(percent) {
        this.state.completed = percent;
        console.log(this.state.completed);
    }*/

    onUploadError(r){

        console.log(r);
    }

    fileChangedHandler(e){
        this.props.uploadErrors({'error' : '', fileType : ''});
        this.props.initializeUpload({'loader' : true});

        console.log(this.state.uploadQ);
        const config = {
            bucketName: BUCKET_NAME,
            albumName: ALBUM_NAME,
            region: REGION,
            accessKeyId: ACCESS_KEY_ID,
            secretAccessKey: SECRET_ACCESS_KEY,
        }

        /******** Extension checking ******/
        let fileType = this.props.fileType ? this.props.fileType : 'image';
        let allowedFileTypes = [];
        switch(fileType) {
            case 'document': allowedFileTypes = ['pdf'];
                break;
            case 'image': allowedFileTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
                break;
            case 'video': allowedFileTypes = ['mp4','flv', 'mpg'];
                break;
            case 'audio': allowedFileTypes = ['mp3','wav', 'flac', 'ogg'];
                break;
            default: allowedFileTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
                break;

        }


        const file = e.target.files[0];
        e.target.value=null
        this.setState({selectedFile: file});
        this.setState({uploadstatus: 'uploading'});

        const fnarr = file.name.split('.');
        var ext = fnarr[fnarr.length-1];

        if(allowedFileTypes.includes(ext)) {

            const uniq_id = new Date().getTime();
            let fn = uniq_id;


            if (this.props.item_type === 'VIGNETS') {

                if (this.props.unique_id === "") {
                    fn = 'cf' + uniq_id+'.jpg';
                } else {
                    fn = this.props.unique_id + ".jpg";
                }

            } else if (this.props.item_type === 'PLAYLIST') {

                if (this.props.unique_id === "") {
                    fn = 'pl' + uniq_id+'.jpg';
                } else {
                    fn = this.props.unique_id + ".jpg";
                }

            } else if (this.props.item_type === 'USER') {

                if (this.props.unique_id === "") {
                    fn = 'u' + uniq_id+'.jpg';
                } else {
                    fn = this.props.unique_id + ".jpg";
                }
            }
            else if (this.props.item_type === 'MY_UPLOADS' || this.props.item_type === 'AUDIO' || this.props.item_type === 'VIDEO' ) {

                if (this.props.unique_id === "") {
                    fn = uniq_id+'.'+ext;
                } else {
                    fn = this.props.unique_id + "."+ext;
                }
            }
            else {
                fn = uniq_id+ ".jpg";
            }

            let tmpobj = {'stat': 'uploading', 'fn': fn}

            this.state.uploadQ[fn] = tmpobj;
            ReactS3.upload(file, config, fn)
                .then((data) => this.onUploadSuccess(data))
                .catch((err) => this.onUploadError(err))
        }
        else{
            this.props.uploadErrors({'error' : 'invalid', fileType : fileType});
        }
    }
    render(){
        return(
                <div className="upload-select">
                    <button className={"icon-lib "+ this.props.type+"-button"}>
                        <input type="file" className="hidden-input" id="imglogo-edit"  onChange={this.fileChangedHandler} />
                    </button>
                </div>
        )
    }
}

UploadFile.propTypes = {
    getUploadedFile : PropTypes.func,
    type: PropTypes.string,
    item_type : PropTypes.string,
    id : PropTypes.string,
    fileType : PropTypes.string,
    progress : PropTypes.string
}

export default  withRouter(connect(null, {
    uploadErrors: uploadActions.uploadErrors,
    initializeUpload : uploadActions.initializeUpload
})(UploadFile));


// WEBPACK FOOTER //
// ./src/components/includes/UploadFile.js